import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres78u/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres78u/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    if (typeof searchParams !== 'undefined') {
      sendParams = {
        p_dtest: (typeof searchParams.dteapprst !== 'undefined' ? searchParams.dteapprst : ''),
        p_dteen: (typeof searchParams.dteappren !== 'undefined' ? searchParams.dteappren : ''),
        p_staappr: (typeof searchParams.staappr !== 'undefined' ? searchParams.staappr : 'P'),
        p_codempid: (typeof searchParams.codempid !== 'undefined' ? searchParams.codempid : '')
      }
    }
    return instance().get(endpoint + '/hres78u/index', { params: sendParams })
  },
  getDetail (detailParams) {
    let searchParams = {
      p_codempid: detailParams.codempid,
      p_dtereq: detailParams.dtereq.replace(/\//g, ''),
      p_numseq: detailParams.numseq,
      p_codlon: detailParams.codlon
    }
    if (isMock) return generator(mocker.detail())
    const params = searchParams.p_codempid + '/' + searchParams.p_dtereq + '/' + searchParams.p_numseq + '/' + searchParams.p_codlon
    return instance().get(endpoint + '/hres78u/detail/' + params)
  },
  getDetailSubmit (detailParams) {
    let searchParams = {
      p_codempid: detailParams.codempid,
      p_dtereq: detailParams.dtereq.replace(/\//g, ''),
      p_numseq: detailParams.numseq,
      p_approvno: detailParams.approvno
    }
    const params = searchParams.p_codempid + '/' + searchParams.p_dtereq + '/' + searchParams.p_numseq + '/' + searchParams.p_approvno
    if (isMock) return generator(mocker.detailSubmit())
    return instance().get(endpoint + '/hres78u/detailsubmit/' + params)
  },
  getDropdowns () {
    if (isMock) return generator(mocker.dropdowns())
    return instance().get(endpoint + '/hres78u/dropdowns')
  },
  getTrailRepayment (popupParams) {
    let searchParams = {
      p_codempid: popupParams.p_codempid,
      p_dtereq: popupParams.p_dtereq.replace(/\//g, ''),
      p_numseq: popupParams.p_numseq,
      p_codlon: popupParams.p_codlon
    }
    if (isMock) return generator(mocker.trailRepayment())
    const params = searchParams.p_codempid + '/' + searchParams.p_dtereq + '/' + searchParams.p_numseq + '/' + searchParams.p_codlon
    return instance().get(endpoint + '/hres78u/detailTab1Popup1/' + params)
  },
  postTableProcess (processParams) {
    let params = {
      p_codempid: processParams.p_codempid,
      p_codlon: processParams.p_codlon,
      p_amtmxlon: processParams.p_amtmxlon,
      p_amtlon: processParams.p_amtlon,
      p_yrelon: processParams.p_yrelon,
      p_mthlon: processParams.p_mthlon,
      p_typintr: processParams.p_typintr,
      p_rateilon: processParams.p_rateilon,
      p_monthst: processParams.p_monthst,
      p_yearst: processParams.p_yearst,
      p_typlonpay: processParams.p_typlonpay,
      p_qtyperiod: processParams.p_qtyperiod,
      p_amtlpay: processParams.p_amtlpay,
      p_mthbon1: processParams.p_mthbon1,
      p_mthbon2: processParams.p_mthbon2,
      p_ratebon: processParams.p_ratebon,
      p_amtpnor: processParams.p_amtpnor,
      p_amtpbon: processParams.p_amtpbon,
      p_pctsalbo: processParams.p_pctsalbo
    }
    if (isMock) return generator(mocker.tableProcess())
    return instance().post(endpoint + '/hres78u/detailTab1Popup1Table', params)
  },
  getPersonaldata (personaldataParams) {
    let searchParams = {
      p_codempid: personaldataParams.p_codempid
    }
    if (isMock) return generator(mocker.datapersonal())
    const params = searchParams.p_codempid
    return instance().get(endpoint + '/hres78u/detailTab1Popup2/' + params)
  },
  postSendApprove (approveParams) {
    let paramJson = {
      '0': {
        p_approvno: approveParams.approvno,
        p_chk_appr: approveParams.chk_appr,
        p_numseq: approveParams.numseq,
        p_dtereq: approveParams.dtereq.replace(/\//g, ''),
        p_dteappr: approveParams.dteappr.replace(/\//g, ''),
        p_staappr: approveParams.flgStaappr,
        p_remark: approveParams.remark,
        p_codempid: approveParams.codempid,
        p_flgwarn: approveParams.flgwarning,
        p_numcont: approveParams.numcont,
        p_dtelonst: approveParams.dtelonst.replace(/\//g, ''),
        p_amtlon: approveParams.amtlon,
        p_numlonreqyr: approveParams.numlonreqyr + '',
        p_numlonreqmth: approveParams.numlonreqmth + '',
        p_typintr: approveParams.typintr,
        p_rateilon: approveParams.rateilon,
        p_codlon: approveParams.codlon
      }
    }
    let sendParams = {
      param_json: JSON.stringify(paramJson),
      remarkApprove: (approveParams.flgStaappr === 'A') ? approveParams.remark : '',
      remarkReject: (approveParams.flgStaappr === 'N') ? approveParams.remark : '',
      flgwarning: approveParams.flgwarning
    }
    if (isMock) return generator(mocker.sendApprove())
    return instance().post(endpoint + '/hres78u/sendApprove', sendParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hres78u/index.js